// Convenzione CSP Lab: interfacce operative → "COGNOME Nome"; titoli/testi discorsivi → "Nome Cognome".
const s = (v) => (v == null ? "" : String(v).trim());
const norm = (v) => s(v).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export const displayName = (a) => {
  if (!a) return "—";
  const ln = s(a.last_name).toUpperCase();
  const fn = s(a.first_name);
  return `${ln} ${fn}`.trim() || "—";
};

export const fullName = (a) => (a ? `${s(a.first_name)} ${s(a.last_name)}`.trim() || "—" : "—");

export const initials = (a) => `${s(a?.last_name).charAt(0)}${s(a?.first_name).charAt(0)}`.toUpperCase() || "?";

export const compareAthletes = (a, b) => {
  const c = norm(a?.last_name).localeCompare(norm(b?.last_name), "it", { sensitivity: "base" });
  return c !== 0 ? c : norm(a?.first_name).localeCompare(norm(b?.first_name), "it", { sensitivity: "base" });
};

export const sortAthletes = (list) => [...(list || [])].sort(compareAthletes);

export const matchesSearch = (a, term) => {
  const q = norm(term);
  if (!q) return true;
  const fn = norm(a?.first_name), ln = norm(a?.last_name);
  return fn.includes(q) || ln.includes(q) || `${ln} ${fn}`.includes(q) || `${fn} ${ln}`.includes(q);
};
